import {
  Box,
  Button,
  CardMedia,
  Grid,
  Modal,
  Slide,
  Typography,
} from "@mui/material";
import summaryImg from "../../../../../assets/Registration Confirmed.svg";
import { useContext, useState } from "react";
import SummaryTable from "./DinamicalSummaryPages/SummaryTable";
import { DataContext } from "../../Context/ContextWrapper";
import { useNavigate } from "react-router-dom";
import RegionDataDetails from "../../RegionDataDetails";

const ModalReservationSummaryNew = (props: {
  openSummary: any;
  onCloseSummary: () => void;
  showRegionDataDetail: boolean;
  setShowRegionDataDetail: (value: boolean) => void;
  summaryData: any;
  appointmentDetails: any;
  onRegionDataClose: () => void;
}) => {
  const context = useContext(DataContext);

  // Funzione navigate per passare da una pagina ad un'altra
  const navigate = useNavigate();

  // Funzione per il passaggio dati dell'appuntamento da modificare
  const appointmentResearchRedirect = async (numeroAppuntamento: string) => {
    navigate("/research", { state: { numeroAppuntamento } });
  };

  const [showDetailedSummary, setShowDetailedSummary] = useState(false);

  const handleShowDetailedSummary = () => {
    setShowDetailedSummary(!showDetailedSummary);
  };

  return (
    <>
      {" "}
      {props.showRegionDataDetail && (
        <Modal
          open={props.showRegionDataDetail}
          keepMounted
          disableAutoFocus={false}
          disableEnforceFocus={false}
        >
          <Slide
            in={props.showRegionDataDetail}
            direction="down"
            timeout={800}
            mountOnEnter
            unmountOnExit
          >
            <Box>
              <RegionDataDetails
                key={String(context?.idPacada || "rd")}
                handleClose={(value: boolean) => {
                  props.setShowRegionDataDetail(value);
                  if (!value) props.onRegionDataClose();
                }}
              />
            </Box>
          </Slide>
        </Modal>
      )}
      <Modal open={props?.openSummary && !props?.showRegionDataDetail}>
        <Slide
          in={props?.openSummary && !props?.showRegionDataDetail}
          direction="down"
          timeout={800}
        >
          {showDetailedSummary ? (
            <Box>
              {/* <DinamicPage handleShowDetailedSummary={handleShowDetailedSummary}></DinamicPage> */}
              <SummaryTable
                handleShowDetailedSummary={handleShowDetailedSummary}
                appointmentDetails={props.appointmentDetails}
              ></SummaryTable>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
              }}
            >
              <Box
                sx={{
                  maxHeight: "170px",
                  minHeight: "170px",
                  minWidth: "300px",
                  maxWidth: "500px",
                  width: "100%",
                  height: "100%",
                  overflowY: "auto",
                  padding: 2,
                  backgroundColor: "white",
                  borderRadius: "4px",
                  boxShadow: 24,
                }}
              >
                <Grid
                  container
                  direction={"column"}
                  justifyContent="center"
                  alignItems={"center"}
                >
                  <Grid item>
                    <Typography
                      component="div"
                      color={"#024E88"}
                      sx={{
                        fontSize: "var(--font-size-125-rem, 20px)",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "160%",
                        letterSpacing: "0.15px",
                      }}
                      fontWeight={"bold"}
                    >
                      {`Prenotazione confermata!`}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <CardMedia component="img" image={summaryImg} />
                  </Grid>
                  <Grid item sx={{ width: "100%" }}>
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid item>
                        <Button
                          variant="outlined"
                          onClick={handleShowDetailedSummary}
                        >
                          Riepilogo prenotazione
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          onClick={
                            context?.statusAvanzamentoPrenotazione !== 3
                              ? props.onCloseSummary
                              : () =>
                                  appointmentResearchRedirect(
                                    context.numeroAppuntamentoRiepilogo
                                  )
                          }
                        >
                          Chiudi
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          )}
        </Slide>
      </Modal>
    </>
  );
};

export { ModalReservationSummaryNew };
